import { useState, useEffect } from "react";

//Chart components
import { AreaChart } from "@tremor/react";
import { ScatterChart } from "@tremor/react";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import EditUserForm from "../users/EditUserForm";
import { useDispatch } from "react-redux";
import { setTabTrigger } from "../transformacije/PokreniTransformaciju";
import { setCredentials } from "../auth/authSlice";
import OrderComponent from "./OrderComponent";

const Dashboard = () => {
  //const [value, setValue] = useState(null);
  const { isAdmin, isKlijent, id } = useAuth();
  //{isKlijent && <h1>Klijent</h1>}
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log("id => ", id);

  //Mozada ovde proveri
  useEffect(() => {
    if (isKlijent) {
      dispatch(setTabTrigger(false));
      navigate(`/dash/user/${id}`);
    }
  }, [isKlijent, id, navigate]);

  return (
    <>
      {isAdmin ? (
        <div className="">
          <header className="mb-3">
            <div className="">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
                Dashboard
              </h1>
            </div>
          </header>
          <hr className="border-t border-slate-950" />
          <main className="">
            <h1>Nesto</h1>
            <OrderComponent />
          </main>
        </div>
      ) : (
        // Ovaj klijent deo moze da bude prazan
        <div className="">
          <header className="mb-3">
            <div className="">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
                Dashboard
              </h1>
            </div>
          </header>
          <hr className="border-t border-slate-950" />
          <main className="">
            <h1>Klijentov</h1>
            {/* <p className="text-lg font-semibold text-gray-700">
              Pripremanje profila...
            </p> */}
          </main>
        </div>
      )}

      {/* Ovde ubacuj onu formu za caht gpt */}
      {/* {isKlijent && id && <EditUserForm userId={id} />} */}
    </>
  );
};
export default Dashboard;
